module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/02d927ce93445be737c7ff43fb98b135.svg";